import { Trans } from 'react-i18next';
import React from 'react';
import classNames from 'classnames/bind';

import { NOTIFY_STATUS } from 'constants/values';

import Text from 'components/Text';

import styles from './Notification.module.css';

import { ReactComponent as SuccessIco } from './img/successIco.svg';
import { ReactComponent as ErrorIco } from './img/errorIco.svg';

import { NotificationProps } from './types';

const cx = classNames.bind(styles);

const Notification = ({ title, status }: NotificationProps) => {
    const isError = status === NOTIFY_STATUS.ERROR;
    const isSuccess = status === NOTIFY_STATUS.SUCCESS;

    const messageBoxClasses = cx('messageBox', {
        success: isSuccess,
        error: isError,
    });

    return (
        <div data-locator="alertMessage">
            <div className={messageBoxClasses}>
                <div className={styles.iconBox}>
                    {isSuccess && <SuccessIco />}
                    {isError && <ErrorIco />}
                </div>
                <Text mediumSmall2>
                    <Trans>{title}</Trans>
                </Text>
            </div>
        </div>
    );
};

export default Notification;
